<div class="fcpl-page">
  <header class="fcpl-header">
    <button class="fcpl-back" type="button" (click)="backToDashboard()">
      <i class="pi pi-arrow-left"></i>
      {{ 'DASHBOARD' | translate }}
    </button>
    <h2>{{ 'FLEXI_COMPLIANCE.PORTAL_WIDGET.LIST_TITLE' | translate }}</h2>
    <p class="fcpl-subtitle">{{ 'FLEXI_COMPLIANCE.PORTAL_WIDGET.LIST_SUBTITLE' | translate }}</p>
  </header>

  <!-- Filter chips -->
  <div class="fcpl-filters" *ngIf="summary && summary.totalCount > 0">
    <span class="fcpl-chip is-green"
          [class.is-active]="activeFilter === 'green'"
          (click)="setFilter('green')">
      <strong>{{ summary.greenCount }}</strong>
      {{ 'FLEXI_COMPLIANCE.SCORE_CHIP.GREEN_LABEL' | translate }}
    </span>
    <span class="fcpl-chip is-yellow"
          [class.is-active]="activeFilter === 'yellow'"
          (click)="setFilter('yellow')">
      <strong>{{ summary.yellowCount }}</strong>
      {{ 'FLEXI_COMPLIANCE.SCORE_CHIP.YELLOW_LABEL' | translate }}
    </span>
    <span class="fcpl-chip is-red"
          [class.is-active]="activeFilter === 'red'"
          (click)="setFilter('red')">
      <strong>{{ summary.redCount }}</strong>
      {{ 'FLEXI_COMPLIANCE.SCORE_CHIP.RED_LABEL' | translate }}
    </span>
    <button type="button" class="fcpl-clear" *ngIf="activeFilter !== null" (click)="setFilter(null)">
      <i class="pi pi-times"></i>
      {{ 'FLEXI_COMPLIANCE.PORTAL_WIDGET.CLEAR_FILTER' | translate }}
    </button>
    <span class="fcpl-total">
      {{ filteredRows.length }} / {{ summary.totalCount }}
      {{ 'FLEXI_COMPLIANCE.PORTAL_WIDGET.BUSINESSES' | translate }}
    </span>
  </div>

  <!-- States -->
  <div *ngIf="loading" class="fcpl-state">
    <i class="pi pi-spin pi-spinner"></i>
  </div>
  <div *ngIf="!loading && summary && summary.totalCount === 0" class="fcpl-state">
    <i class="pi pi-chart-pie"></i>
    <p>{{ 'FLEXI_COMPLIANCE.PORTAL_WIDGET.EMPTY' | translate }}</p>
  </div>
  <div *ngIf="!loading && summary && summary.totalCount > 0 && filteredRows.length === 0" class="fcpl-state">
    <i class="pi pi-filter-slash"></i>
    <p>{{ 'FLEXI_COMPLIANCE.PORTAL_WIDGET.EMPTY_FILTER' | translate }}</p>
  </div>

  <!-- Table -->
  <table class="fcpl-table" *ngIf="!loading && filteredRows.length > 0">
    <thead>
      <tr>
        <th>{{ 'FLEXI_COMPLIANCE.PORTAL_WIDGET.COLUMN_BUSINESS' | translate }}</th>
        <th>{{ 'FLEXI_COMPLIANCE.PORTAL_WIDGET.COLUMN_SCORE' | translate }}</th>
        <th>{{ 'FLEXI_COMPLIANCE.PORTAL_WIDGET.COLUMN_ADVISOR' | translate }}</th>
        <th>{{ 'FLEXI_COMPLIANCE.PORTAL_WIDGET.COLUMN_COMPLETED' | translate }}</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of filteredRows">
        <td class="fcpl-name">{{ row.businessName }}</td>
        <td>
          <span class="fcpl-score" [ngClass]="smileyClass(row.smiley)">
            <span class="dot"></span>
            <strong>{{ row.percentage }}%</strong>
            <small>{{ smileyLabelKey(row.smiley) | translate }}</small>
          </span>
        </td>
        <td>
          <ng-container *ngIf="row.hseAdvisorName; else noAdvisor">
            <i class="pi pi-user fcpl-advisor-icon"></i>
            {{ row.hseAdvisorName }}
          </ng-container>
          <ng-template #noAdvisor><span class="fcpl-muted">—</span></ng-template>
        </td>
        <td class="fcpl-muted">{{ row.completedOn | date:'mediumDate' }}</td>
        <td class="fcpl-actions">
          <button type="button" class="fcpl-rmode-btn"
                  (click)="openFlexi(row)"
                  [attr.title]="'FLEXI_COMPLIANCE.PORTAL_WIDGET.OPEN_BUSINESS' | translate">
            <i class="pi pi-external-link"></i>
            {{ 'FLEXI_COMPLIANCE.PORTAL_WIDGET.OPEN_FLEXI' | translate }}
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
